export default {
  getFolders: (token, descendants = true) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `https://www.wrike.com/api/v4/folders?descendants=${descendants}`,
      requestOptions
    )
    .then(res => res.json());
  },
  getFolder: (token, id, descendants = true) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `https://www.wrike.com/api/v4/folders/${id}/folders?descendants=${descendants}`,
      requestOptions
    )
    .then(res => res.json());
  },
};
